import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { LiveInstantBookState } from './instantBook.models';
import { initialLiveInstantBookState } from './instantBook.models';

export function liveInstantBookReducer(
  state: LiveInstantBookState = initialLiveInstantBookState,
  action: Action,
): LiveInstantBookState {
  switch (action.type) {
    case 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_WORKFLOW_INIT':
      return addOrReplaceKey(state, action.orderId, { status: 'INIT' as const });
    case 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_WORKFLOW_ABORTED':
      return removeKey(state, action.orderId);
    case 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_WORKFLOW_COMPLETED':
      return removeKey(state, action.orderId);
    case 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_REQUESTED':
      return patchKey(state, action.orderId, () => ({ status: 'IN_PROGRESS' as const }));
    case 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_RECEIVED':
      return patchKey(state, action.orderId, () => ({ status: 'SUCCESS' as const }));
    case 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_FAILED':
      return patchKey(state, action.orderId, () => ({ status: 'FAILED' as const, error: action.error }));
    case 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_REJECTED':
      return patchKey(state, action.orderId, () => ({ status: 'REJECTED' as const, error: action.error }));
    default:
      return state;
  }
}
